import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useTranslate from '../../../../Hooks/useTranslate';

/**
 * NoData — shared "no results" line for the report cards.
 */
const NoData = function NoData() {
  const theme = useTheme();
  const translate = useTranslate();
  return (
    <Typography variant="body2" sx={{ color: theme.custom.mobile.mutedColor }}>
      {translate('MOBILE_NO_ITEMS')}
    </Typography>
  );
};

export default NoData;
